<script lang="ts">
  import CoverImage from '$components/cover-image.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { zoomOnScrollHandler } from '$lib/transitions';
  import type { CoverStoryblok } from '$types/bloks';
  import { reducedMotion } from '@significa/svelte-toaster';
  import { onMount } from 'svelte';

  export let block: CoverStoryblok;

  onMount(() => {
    if (block.slight_zoom_on_scroll && !$reducedMotion) {
      const handler = () => {
        zoomOnScrollHandler(imageContainer, (n) => (scale = n));
      };
      window.addEventListener('scroll', handler);
      return () => window.removeEventListener('scroll', handler);
    }
  });

  let imageContainer: HTMLElement;
  let scale = 1;
</script>

<div use:storyblokEditable={block} bind:this={imageContainer}>
  <CoverImage title={block.title} image={block.image} class="py-2 lg:py-8" {scale} />
</div>
